import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Message } from '@copilot/models';
import { VideoPlayer } from '../video-player/videoPlayer';

@Component({
  selector: 'shared-message',
  imports: [
    VideoPlayer,
    MatTooltip,
    CommonModule,
  ],
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
})
export class MessageComponent {
  @Input() message!: Omit<Message, 'mediaUrls'> & { mediaUrls?: string[], mediaUrl?: string };
  @Input() userView = false;

  get mediaUrls(): string[] {
    if (this.message.mediaUrls && this.message.mediaUrls.length > 0) {
      return this.message.mediaUrls;
    }
    if (this.message.mediaUrl) {
      return [this.message.mediaUrl];
    }
    return [];
  }

  get isEmojiOnly(): boolean {
    const textWithoutEmojis = this.message.body.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '').trim();
    return textWithoutEmojis.length === 0 && this.mediaUrls.length === 0;
  }
}
